import { makeStyles } from '@material-ui/core/styles';

const useRecommendationStyles = makeStyles((theme) => ({
  rowSpacer: {
    height: 30,
  },
  textRowSpacer: {
    [theme.breakpoints.up('sm')]: {
      height: 50,
    },
  },
  buttonWidth: {
    width: 110,
    marginTop: 10,
  },
  resendButtonWidth: {
    width: 220,
    marginTop: 10,
  },
  textRowLabelSpacer: {
    [theme.breakpoints.down('md')]: {
      height: 30,
      paddingTop: 5,
    },
    [theme.breakpoints.up('md')]: {
      height: 50,
      paddingTop: 8,
    },
  },
  buttonSpacer: {
    marginTop: 20,
  },
}));

export default useRecommendationStyles;
